import React from 'react'

import LoadingView from '../componentKit/LoadingView'

const NotFound = () => (
  <LoadingView title="Ничего не найдено, такой страницы не существует"/>
)

export default NotFound



// WEBPACK FOOTER //
// /var/www/build-lk-1/src/components/profile/NotFound.js